import * as CookieConsent from 'vanilla-cookieconsent';
/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */
CookieConsent.run({

	// root: 'body',
	// autoShow: true,
	// disablePageInteraction: true,
	// hideFromBots: true,
	// mode: 'opt-in',
	revision: 2,

	cookie: {
		name: 'cc_cookie',
		// domain: location.hostname,
		// path: '/',
		// sameSite: "Lax",
		// expiresAfterDays: 365,
	},

	// https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
	guiOptions: {
		consentModal: {
			layout: 'cloud inline',
			position: 'middle center',
			equalWeightButtons: true,
			flipButtons: false
		},
		preferencesModal: {
			layout: 'box',
			equalWeightButtons: true,
			flipButtons: false
		}
	},

	onFirstConsent: ({cookie}) => {
		// console.log('onFirstConsent fired',cookie);
	},

	onConsent: ({cookie}) => {
		// console.log('onConsent fired!', cookie)

		cookie.categories.forEach(function (category) {
			if (category == 'analytics') {
				gtag('consent', 'update', {
					analytics_storage: "granted",
					functionality_storage: "granted",
				});
			}
			if (category == 'advertising') {
				gtag('consent', 'update', {
					ad_storage: "granted",
					ad_user_data: "granted",
					ad_personalization: "granted",
					functionality_storage: "granted",
					personalization_storage: "granted",
				});
			}
		});

	},

	onChange: ({changedCategories, changedServices}) => {
		// console.log('onChange fired!', changedCategories, changedServices);
	},

	onModalReady: ({modalName}) => {
		// console.log('ready:', modalName);
	},

	onModalShow: ({modalName}) => {
		// console.log('visible:', modalName);
	},

	onModalHide: ({modalName}) => {
		// console.log('hidden:', modalName);
	},

	categories: {
		necessary: {
			enabled: true,  // this category is enabled by default
			readOnly: true  // this category cannot be disabled
		},
		analytics: {
			autoClear: {
				cookies: [
					// {
					// 	name: /^_ga/,   // regex: match all cookies starting with '_ga'
					// },
					// {
					// 	name: '_gid',   // string: exact cookie name
					// }
				]
			},

			// https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
			services: {
				// ga: {
				// 	label: 'Google Analytics',
				// 	onAccept: () => {},
				// 	onReject: () => {}
				// },
				// youtube: {
				// 	label: 'Youtube Embed',
				// 	onAccept: () => {},
				// 	onReject: () => {}
				// },
			}
		},
		advertising: {}
	},

	language: {
		default: 'en',
		translations: {
			en: {
				consentModal: {
					title: 'We use cookies',
					description: 'We use cookies on our website to give you the most relevant experience by remembering your preferences and repeat visits. By clicking “Accept All”, you consent to the use of ALL the cookies. However you may visit the settings to provide a controlled consent.',
					acceptAllBtn: 'Accept all',
					acceptNecessaryBtn: 'Reject all',
					showPreferencesBtn: 'Settings',
					// closeIconLabel: 'Reject all and close modal',
					footer: `
						<a href="/cookie-policy" target="_blank">Cookie Policy</a>
						<a href="/privacy-policy" target="_blank">Privacy Policy</a>
					`,
				},
				preferencesModal: {
					title: 'Manage cookie preferences',
					acceptAllBtn: 'Accept all',
					acceptNecessaryBtn: 'Reject all',
					savePreferencesBtn: 'Accept current selection',
					closeIconLabel: 'Close modal',
					serviceCounterLabel: 'Service|Services',
					sections: [
						{
							title: 'Your Privacy Choices',
							description: `In this panel you can express some preferences related to the processing of your personal information. You may review and change expressed choices at any time by resurfacing this panel via the provided link. To deny your consent to the specific processing activities described below, switch the toggles to off or use the “Reject all” button and confirm you want to save your choices.`,
						},
						{
							title: 'Strictly Necessary',
							description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',

							//this field will generate a toggle linked to the 'necessary' category
							linkedCategory: 'necessary',
							cookieTable: {
								caption: '',
								headers: {
									col1: 'Cookie',
									col2: 'Domain',
									col3: 'Description',
									col4: 'Expiry'
								},
								body: [
									{
										col1: 'XSRF-TOKEN',
										col2: 'www.stoneandsurfaces.co.uk',
										col3: 'This cookie is used for security purposes.',
										col4: '2 hours',
									},
									{
										col1: 'stone_and_surfaces_session',
										col2: 'www.stoneandsurfaces.co.uk',
										col3: 'This cookie is used to identify your browsing session and authenticated user account',
										col4: '2 hours',
									},
									{
										col1: 'shopping_basket_id',
										col2: 'www.stoneandsurfaces.co.uk',
										col3: 'This cookies is used to identify your shopping basket record.',
										col4: '1 month',
									}

								]
							}
						},
						{
							title: 'Performance and Analytics',
							description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
							linkedCategory: 'analytics',
							cookieTable: {
								caption: 'Cookie table',
								headers: {
									col1: 'Cookie',
									col2: 'Domain',
									col3: 'Description',
									col4: 'Expiry'
								},
								body: [
									{
										col1: 'test_cookie',
										col2: '.doubleclick.net',
										col3: 'The test_cookie is set by doubleclick.net and is used to determine if the user\'s browser supports cookies.',
										col4: '15 minutes',
									},
									{
										col1: '_ga',
										col2: '.stoneandsurfaces.co.uk',
										col3: 'The _ga cookie, installed by Google Analytics, calculates visitor, session and campaign data and also keeps track of site usage for the site\'s analytics report. The cookie stores information anonymously and assigns a randomly generated number to recognize unique visitors.',
										col4: '2 years',
									},
									{
										col1: '_gid',
										col2: '.stoneandsurfaces.co.uk',
										col3: 'Installed by Google Analytics, _gid cookie stores information on how visitors use a website, while also creating an analytics report of the website\'s performance. Some of the data that are collected include the number of visitors, their source, and the pages they visit anonymously.',
										col4: '1 day',
									},
									{
										col1: '_gat_UA-165062631-1',
										col2: '.stoneandsurfaces.co.uk',
										col3: 'A variation of the _gat cookie set by Google Analytics and Google Tag Manager to allow website owners to track visitor behaviour and measure site performance. The pattern element in the name contains the unique identity number of the account or website it relates to.',
										col4: '1 minute',
									},
									{
										col1: '_ga_K4B0DKQW0T',
										col2: '.stoneandsurfaces.co.uk',
										col3: 'This cookie is installed by Google Analytics.',
										col4: '2 years',
									},
									{
										col1: '_hjSessionUser_3171510',
										col2: '.stoneandsurfaces.co.uk',
										col3: 'Hotjar sets this cookie to identify the user session',
										col4: '1 year',
									},
									{
										col1: '_hjFirstSeen',
										col2: '.stoneandsurfaces.co.uk',
										col3: 'Hotjar sets this cookie to identify a new user\'s first session. It stores a true/false value, indicating whether it was the first time Hotjar saw this user.',
										col4: '30 minutes',
									},
									{
										col1: '_hjIncludedInSessionSample',
										col2: 'www.stoneandsurfaces.co.uk',
										col3: 'Hotjar sets this cookie to know whether a user is included in the data sampling defined by the site\'s daily session limit.',
										col4: '2 minutes',
									},
									{
										col1: '_hjSession_3171510',
										col2: '.stoneandsurfaces.co.uk',
										col3: 'Hotjar sets this cookie to identify the user session',
										col4: '30 minutes',
									},
									{
										col1: '_hjIncludedInPageviewSample',
										col2: 'www.stoneandsurfaces.co.uk',
										col3: 'Hotjar sets this cookie to know whether a user is included in the data sampling defined by the site\'s pageview limit.',
										col4: '2 minutes',
									},
									{
										col1: '_hjAbsoluteSessionInProgress',
										col2: '.stoneandsurfaces.co.uk',
										col3: 'Hotjar sets this cookie to detect the first pageview session of a user. This is a True/False flag set by the cookie.',
										col4: '30 minutes',
									}
								]
							}
						},
						{
							title: 'Targeting and Advertising',
							description: 'These cookies are used to make advertising messages more relevant to you and your interests. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.',
							linkedCategory: 'advertising',
							cookieTable: {
								caption: 'Cookie table',
								headers: {
									col1: 'Cookie',
									col2: 'Domain',
									col3: 'Description',
									col4: 'Expiry'
								},
								body: [
									{
										col1: '_gcl_au',
										col2: '.stoneandsurfaces.co.uk',
										col3: 'Provided by Google Tag Manager to experiment advertisement efficiency of websites using their services.',
										col4: '3 months',
									},
									{
										col1: 'IDE',
										col2: '.doubleclick.net',
										col3: 'Google DoubleClick IDE cookies are used to store information about how the user uses the website to present them with relevant ads and according to the user profile.',
										col4: '1 year 24 days',
									},
									{
										col1: '_fbp',
										col2: '.stoneandsurfaces.co.uk',
										col3: 'This cookie is set by Facebook to display advertisements when either on Facebook or on a digital platform powered by Facebook advertising, after visiting the website.',
										col4: '3 months',
									}
								]
							}
						},
						{
							title: 'More information',
							description: 'For any queries in relation to my policy on cookies and your choices, please <a href="/contact-us">contact us</a>'
						}
					]
				}
			}
		}
	}
});